/* unplugin-vue-components disabled */import script from "./LoginRegisterBox.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginRegisterBox.vue?vue&type=script&setup=true&lang=js"

import "./LoginRegisterBox.vue?vue&type=style&index=0&id=5d336aa0&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d336aa0"]])

export default __exports__